declare global {
    interface Window {
        // tslint:disable-next-line: no-any
        // oxlint-disable-next-line typescript/no-explicit-any
        dataLayer: any[];
    }
}

interface EventProps {
    category: string;
    action: string;
    label?: string | null;
    metadata?: Record<string, number | string | boolean | null | undefined>;
    value?: number | null;
}
export const trackEvent = ({ category, action, label = null, metadata, value = null }: EventProps) => {
    window.dataLayer = window.dataLayer || [];
    const payload: {
        [key: string]: string | number | boolean;
    } = {
        event: `${category}_${action}`,
    };
    if (label) {
        payload.label = label;
    }
    if (value) {
        payload.value = value;
    }
    if (metadata) {
        Object.entries(metadata).forEach(([key, entryValue]) => {
            if (entryValue !== null && entryValue !== undefined) {
                payload[key] = entryValue;
            }
        });
    }
    window.dataLayer.push(payload);
};
